import {Injectable} from '@angular/core';
import * as APIM from '@common/utils/dist/models/api-messages.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {
  WebsocketMessageProcessor,
  WSMessageProcessorInput,
  WSMessageProcessorOutput,
} from './websocket-message-processor';
import {NEVER, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {WSMessageReceiverService} from '@services/ws-message-receiver.service';
import {UserDetailsStore} from '@stores/user-details.store';
import {mergeUserDetails} from '@utils/user-details-utils';

@Injectable()
export class UserDetailsMessageProcessor implements WebsocketMessageProcessor {
  readonly intents = [
    APIM.EventIntent.UserDetailsFetched,
    APIM.EventIntent.UserDetailsUpserted,
  ];

  constructor(
    private userDetailsStore: UserDetailsStore,
    private wsMessageReceiverService: WSMessageReceiverService,
  ) {}

  processMessage(
    params: WSMessageProcessorInput,
  ): Observable<WSMessageProcessorOutput> {
    const msg = params.msg;
    if (this.intents.includes(msg.int)) {
      return this.wsMessageReceiverService
        .receive<APIM.RespondToFetchRequest>(msg)
        .pipe(
          map((eventData) => {
            const details = eventData.c as unknown as PL2.UserDetails[];
            if (Array.isArray(details) && details.length > 0) {
              mergeUserDetails(details[0], this.userDetailsStore);
            }
            params.wsAPI.result(msg, eventData);
          }),
        );
    } else if (
      msg.int === APIM.EventIntent.UserDetailsRecentLessonsUpserted ||
      msg.int === APIM.EventIntent.UserDetailsDeleted
    ) {
      return of(params.wsAPI.result(msg));
    }
    return NEVER;
  }
}
